
import React from 'react';
import { PlusCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyServicesStateProps {
  handleAddService: () => void;
}

const EmptyServicesState: React.FC<EmptyServicesStateProps> = ({ handleAddService }) => {
  return (
    <div className="bg-muted p-4 rounded-md text-center">
      <p className="text-muted-foreground">No services added to this subscription yet.</p>
      <Button variant="outline" className="mt-4" onClick={handleAddService} size="sm">
        <PlusCircle className="h-4 w-4 mr-2" />
        Add Your First Service
      </Button>
    </div>
  );
};

export default EmptyServicesState;
